import Axios from '../axios.config'
import qs from 'qs'
import bus from '../components/bus'

export default {
  'state': {
    findid: '',
    scId: [],
    webPath: '',
    paId: [],
    boths: [],
    cansId: 1,
    i: 0,//无穷返回到根目录为止
    flag: false,
    isClose: false,
    parentId: -1,
    type: 'select',
    nodeId: 0,
    checkId: [], //全选的ID
    checkType: [], //全选的文件类型
    checkName: [], //全选的文件类型
    wjjId: -1, //鼠标右击文件夹保存文件的Id
    loading: false, //加载loading
    ecId: -1,
    treeNode: null,
    role: '',
    lastSize: '-',
    total: 0,
    serverURL: '/',
  },
  getters: {},
  mutations: {},
  actions: {
    selectAll({ state }) {
      if (state.scId.length < 1) {
        return
      }
      state.checkId = []
      state.checkType = []
      state.flag = !state.flag
      for (let i = 0; i < state.scId.length; i++) {
        if (state.flag) {
          state.scId[i].check = true
          if (state.scId[i].check) {
            state.checkId.push(state.scId[i].clid == undefined ? state.scId[i].mid : state.scId[i].clid)
            state.checkType.push(state.scId[i].style)
            state.checkName.push(state.scId[i].text)
          }
        } else {
          state.scId[i].check = false
        }
      }
    },

    fn({ state }, res) {
      if (res.mfId === -1) {
        //bus.$elementMessage("禁止在根目录上传文件", "error")
        state.cansId = res.mfId
        return
      }
      state.loading = true //加载loading
      state.flag = false //重置控制全选的变量
      state.checkId = []//点击下个页面时，清空当前页面选中的ID的值
      state.checkType = []//点击下个页面时，清空当前页面选中的type的值


      let arr = ''
      if (res) {
        state.cansId = res.mfId
        arr = res.parentId

        if (arr !== state.paId[0]) {
          state.paId.unshift(arr)
        }
      }

      Axios({
        url: '/etv/findAllMaterial.json',
        method: 'post',
        data: {
          'id': res.mfId,
          pageNum: 1, pageSize: 24,
        },
        transformRequest: [function (data) {
          if (data instanceof FormData) {
            return data
          }
          data = qs.stringify(data)
          return data
        }],
      }).then(function (resu) {
        let subnode = []
        let code = resu.data.code
        if (code === 0) {
          //文件夹为空的话给用户一个提示
          let serverUrl = bus.upFileUrl
          let message = resu.data.data.materialList
          state.total = resu.data.data.totalNum
          if (resu.data.data === '') {
            bus.$elementMessage('此文件夹为空文件夹', 'success')
            state.loading = false //加载loading
            state.scId = []
            return
          }

          for (let i = 0; i < message.length; i++) {
            subnode.push({
              'check': false,
              'clid': message[i].mtId,//文件ID
              'suffix': message[i].suffix,
              'text': message[i].name,
              'src2':  serverUrl + (() => {
                if (message[i].url.startsWith("/")) {
                  return message[i].url.substr(1)
                }
                return message[i].url
              })(),
              'src': serverUrl + (message[i].screenshotUrl ? message[i].screenshotUrl : message[i].url),
              'src1': serverUrl + message[i].videoViewUrl,
              'style': message[i].style,
              'faterId': message[i].parentId, //父级ID
              'type': message[i].type,
              'mtSize': message[i].mtSize,
              'mtId': message[i].mtId,
              'isBindPm': message[i].isBindPm,
            })
          }
          state.scId = subnode

          state.loading = false //加载loading
        } else {

          bus.$elementMessage('加载出错', 'error')
          state.loading = false //加载loading
        }
      })
    },

    close({ state }) {
      state.isClose = false
    },
    //获取素材管理的tree
    async mSetTree({ state, dispatch }, data) {
      var zTree
      var t = $('#fodderManage')
      let rMenu = $('.rMenu')

      let funcs = {
        RightClick: function (event, tree, treeNode) {

          $('.curSelectedNode').removeClass('curSelectedNode')
          $(event.target).parent().addClass('curSelectedNode')
          state.treeNode = treeNode
          if (!treeNode) {
            return
          }
          funcs.showRMenu(treeNode.style, event.clientX, event.clientY, event.screenY, treeNode.mfId)
        },
        showRMenu: function (type, x, y, y1, mfId) {
          if (mfId == 1) {
            return
          }
          let H = $(document).height()
          rMenu.hide()

          if (type == 'folder' && mfId !== 1) {
            $('#rMenu_one').show()
            if (H - 120 - y1 <= $('#rMenu_one').height()) {
              y = y - $('#rMenu_one').height()
            }
          } else if (type == 'topFolder' || mfId == 1) {
            $('#rMenu_tow').show()
            if (H - 120 - y1 <= $('#rMenu_tow').height()) {
              y = y - $('#rMenu_tow').height()
            }
          }
          rMenu.css({ 'top': y + 'px', 'left': x + 'px', 'visibility': 'visible' }) //设置右键菜单的位置、可见
          $('body').bind('mousedown', funcs.BodyMouseDown)
        },
        BodyMouseDown: function (event) {
          if (!(event.target.id == 'rMenu' || $(event.target).parents('.rMenu').length > 0)) {
            rMenu.css({ 'visibility': 'hidden' })
          }
        },
        ajaxGetNodes: function (treeNode, reloadType) {
          var zTree = $.fn.zTree.getZTreeObj('fodderManage')
          if (reloadType == 'refresh') {

            zTree.updateNode(treeNode)
          }
          zTree.reAsyncChildNodes(treeNode, reloadType, true)
        },
      }

      var setting = {
        async: {
          enable: true,
          url: '/etv/findAllOrOneFolder.json',
          headers: {
            token: localStorage.getItem('token1'),
          },
          autoParam: ['id=id'],
          otherParam: {
            'id': function () {
              return state.ecId
            },
            'type': function () {
              return state.type
            },
          },
          dataFilter: filter,
        },
        view: {
          keep: {
            leaf: true,
            parent: true,
          },
          dblClickExpand: false,
          showLine: true,
          selectedMulti: false,
        },
        data: {
          keep: {
            leaf: true,
            parent: true,
          },
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pId',
            rootPId: '',
          },
        },

        callback: {
          beforeClick: function (treeId, treeNode) {
            $('.curSelectedNode').removeClass('curSelectedNode')
            $(event.target).parent().addClass('curSelectedNode')
            let f = treeNode
            state.treeNode = treeNode
            dispatch('fn', f)//传递函数和传值的方式
            $('.curSelectedNode').removeClass('curSelectedNode')
          },
          onRightClick: funcs.RightClick,
        },
      }

      function filter(treeId, parentNode, childNodes) {
        if (childNodes.code == 401) {
          localStorage.removeItem('token1')
          Router.push('/login')
        }
        if (parentNode) {
          let data_new = childNodes.data.children
          if (data_new[0].children === undefined) {
            data_new[0].children = []
          }
          data_new = JSON.parse(JSON.stringify(data_new).replace(/EC_NAME/g, 'name'))
          data_new.open = true
          return data_new
        } else {
          let obj = {}
          obj.name = bus.$t("material.material_group")
          let data_new = childNodes.data.children
          state.lastSize = childNodes.data.lastSize
          localStorage.setItem('lastSize', childNodes.data.lastSize)
          let data = data_new.filter(function (item) {
              if (item.type == 'folder') {
                return true
              } else {
                return false
              }
            },
          )

          obj.children = data
          obj.open = true
          obj.mfId = -1
          obj.style = 'topFolder'
          obj.icon = '/web/static/images/icon/folder.png'
          return obj
        }
      }

      await function () {
        zTree = $.fn.zTree.init(t, setting)
      }()
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/material.js